export default {
    baseURLParam: '/api/v1/notifications/local/',
    notificationDetailsData: 'details?notificationid=',
    customerIdData: '&customerid=',
    downloadDocument: '/api/v1/pios/document?documentid=',
    downloadLocalAttachment: 'attachment/downloadurl?',
    apiKey: 'JO7shhIkpz35Ct28pcd0F7QhNjZOUZWh8xwgbwfs',
    feedBackParam: '/api/v1/notifications/contact/feedback',
    notificationDetailsNonDialogData: '/api/v1/notifications/nonregistered/local/details?',
    nonDialogDownloadUrl: '/api/v1/notifications/nonregistered/local/attachment/downloadurl?',
    nonDialogFeedbackSubmit: '/api/v1/notifications/nonregistered/contact/feedback?',
    getAccountDropdownList: '/api/v1/notifications/account',
    getAccountDetails: '/api/v1/notifications/accountById?accountId=',
    getSignedURLForFileUpload:'v1/notifications/local/attachment/uploadurl?Filename=',
    getNonDialogSignedURLForFileUpload:'v1/notifications/nonregistered/local/attachment/uploadurl?Filename=',
    downloadAttachment: 'v1/notifications/local/attachment/downloadurl?',
};
  